export const claims = {
  // Claim Business Modal
  "claims.modal.title": "Réclamer cette entreprise",
  "claims.modal.close": "Fermer",
  "claims.modal.verify.title": "Vérification",
  "claims.modal.verify.description": "Pour réclamer {businessName}, vous devez vérifier que vous êtes le propriétaire.",
  "claims.modal.verify.business_email": "Email de l'entreprise:",
  "claims.modal.verify.your_email": "Votre email:",
  "claims.modal.verify.not_available": "Non disponible",
  "claims.modal.verify.email_match_title": "Vérification Email",
  "claims.modal.verify.email_match_success": "Votre email correspond à celui de l'entreprise. Vous pouvez réclamer cette entreprise.",
  "claims.modal.verify.email_match_warning": "Votre email ne correspond pas à celui de l'entreprise. Veuillez utiliser l'email professionnel de l'entreprise ou contacter le support.",
  "claims.modal.verify.cancel": "Annuler",
  "claims.modal.verify.continue": "Continuer",
  
  // Confirm Step
  "claims.modal.confirm.title": "Confirmer la réclamation",
  "claims.modal.confirm.description": "En réclamant {businessName}, vous confirmez que vous êtes le propriétaire ou un représentant autorisé de cette entreprise. Vous aurez accès au tableau de bord pour gérer les informations, les avis et les messages.",
  "claims.modal.confirm.benefits_title": "Avantages que vous obtiendrez:",
  "claims.modal.confirm.benefit_manage": "Gérer les informations de l'entreprise",
  "claims.modal.confirm.benefit_reviews": "Répondre aux avis clients",
  "claims.modal.confirm.benefit_stats": "Accéder aux statistiques",
  "claims.modal.confirm.benefit_messages": "Gérer les messages et demandes",
  "claims.modal.confirm.back": "Retour",
  "claims.modal.confirm.submit": "Confirmer la réclamation",
  "claims.modal.confirm.submitting": "Envoi...",
  
  // Success Step
  "claims.modal.success.title": "Demande soumise !",
  "claims.modal.success.description": "Votre demande de réclamation pour {businessName} a été soumise. Notre équipe va vérifier vos informations et vous recevrez une confirmation par email.",
  "claims.modal.success.close": "Fermer",
  
  // Admin Claims Management
  "claims.admin.title": "Réclamations de Fournisseurs",
  "claims.admin.subtitle": "Gérez les demandes de propriété des entreprises",
  "claims.admin.pending_count": "{count} en attente",
  "claims.admin.table.business": "Entreprise",
  "claims.admin.table.claimant": "Demandeur",
  "claims.admin.table.business_email": "Email entreprise",
  "claims.admin.table.date": "Date",
  "claims.admin.table.status": "Statut",
  "claims.admin.table.actions": "Actions",
  "claims.admin.status.pending": "En attente",
  "claims.admin.status.approved": "Approuvé",
  "claims.admin.status.rejected": "Refusé",
  "claims.admin.no_claims": "Aucune demande de réclamation en attente",
  "claims.admin.no_claims_icon": "Tout est à jour",
  "claims.admin.view_details": "Voir détails",
  
  // Claim Detail Modal
  "claims.detail.title": "Détails de la réclamation",
  "claims.detail.close": "Fermer",
  "claims.detail.business_info": "Entreprise",
  "claims.detail.business_name": "Nom:",
  "claims.detail.business_email_label": "Email:",
  "claims.detail.business_phone": "Téléphone:",
  "claims.detail.business_address": "Adresse:",
  "claims.detail.business_location": "Localisation:",
  "claims.detail.claimant_info": "Demandeur",
  "claims.detail.claimant_name": "Nom:",
  "claims.detail.claimant_email": "Email:",
  "claims.detail.claimant_date": "Date:",
  "claims.detail.email_verification": "Vérification Email",
  "claims.detail.email_match": "Les emails correspondent parfaitement",
  "claims.detail.email_mismatch": "Les emails ne correspondent pas. Vérification manuelle requise.",
  "claims.detail.notes.label": "Notes (optionnel)",
  "claims.detail.notes.placeholder": "Ajouter des notes sur cette décision...",
  "claims.detail.cancel": "Annuler",
  "claims.detail.reject": "Refuser",
  "claims.detail.approve": "Approuver",
  "claims.detail.not_available": "N/A",
  
  // Notifications
  "claims.notification.approved_title": "Félicitations ! Votre profil est approuvé",
  "claims.notification.approved_message": "Votre entreprise \"{businessName}\" a été validée par notre équipe. Vous pouvez maintenant recevoir des commandes.",
  "claims.notification.claim_approved": "Demande approuvée avec succès",
  "claims.notification.claim_rejected": "Demande refusée",
  "claims.notification.claim_submitted": "Votre demande de réclamation a été soumise avec succès",
  "claims.notification.error_submit": "Erreur lors de la soumission de la demande",
  "claims.notification.error_approve": "Erreur lors de l'approbation",
  "claims.notification.error_reject": "Erreur lors du refus",
  
  // Sidebar
  "claims.sidebar.menu": "Réclamations",
  "claims.sidebar.page_title": "Réclamations Fournisseurs",
  
  // Supplier Page Button
  "claims.supplier.button": "Vous possédez cette entreprise ?",
  
  // Errors
  "claims.error.unauthorized": "Non autorisé",
  "claims.error.user_not_found": "Utilisateur non trouvé",
  "claims.error.supplier_not_found": "Fournisseur non trouvé",
  "claims.error.already_claimed": "Cette entreprise a déjà été réclamée",
  "claims.error.claim_not_found": "Demande de réclamation non trouvée",
  "claims.error.already_processed": "Cette demande a déjà été traitée",
  "claims.error.admin_only": "Accès refusé. Seuls les administrateurs peuvent effectuer cette action.",
};

export default claims;
